export function QpuiBreadcrumbDirective(): ng.IDirective {
    return {
        transclude: true,
        require: ["^qpuiBreadcrumb"],
        controller: [function name() {

        }],
        replace: true,
        template: require("./qpui-breadcrumb.template.html").default,
        link: (scope, element, attributes, ctrls) => {

            if (!ctrls) {
                return;
            }
            let selfCtrl = ctrls[0];

            // 分隔符
            selfCtrl.divider = attributes.divider || ">";
        }
    }
}